export default __webpack_public_path__ + "static/media/Carouselimage2.744be0de.jpg";